/**
 * Copy-to-clipboard for the mega menu discount code (blocks/_mega-coupon.liquid). The listener is on the document, so
 * it also works on the copies of the block in the phone menu (assets/mega-menu-mobile.js).
 */

/** @param {string} text */
async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    // Older browsers, or no clipboard permission: fall back to a temporary text field.
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.append(field);
    field.select();
    document.execCommand('copy');
    field.remove();
  }
}

/** @type {WeakMap<Element, number>} */
const resetTimers = new WeakMap();

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-mm-copy]') : null;
  if (!button) return;

  event.preventDefault();
  await copyText(button.getAttribute('data-mm-copy') ?? '');

  const hint = button.querySelector('[data-copy-hint]');
  if (!(hint instanceof HTMLElement)) return;

  hint.dataset.original ??= hint.textContent ?? '';
  hint.textContent = button.getAttribute('data-copied-label') || 'Copied!';
  button.setAttribute('data-copied', '');

  clearTimeout(resetTimers.get(button));
  resetTimers.set(
    button,
    window.setTimeout(() => {
      hint.textContent = hint.dataset.original ?? '';
      button.removeAttribute('data-copied');
    }, 2000)
  );
});